/**
 * TODO temperory hack. This is to be moved to PapJs and this merging should be handled by schema desgin and prime mappers
 */
export function mergeProductStrings(infoOmnitureData: any, offersOmnitureData: any) {
  if (
    infoOmnitureData.adobeMappedData &&
    infoOmnitureData.adobeMappedData.products &&
    offersOmnitureData &&
    offersOmnitureData.adobeMappedData &&
    offersOmnitureData.adobeMappedData.products
  ) {
    const rooms = offersOmnitureData.adobeMappedData.products.split('&');
    const hotel = infoOmnitureData.adobeMappedData.products;
    infoOmnitureData.adobeMappedData.products = rooms.map(room => `${hotel}${room}`).join(',');
    offersOmnitureData.adobeMappedData.products = '';
  }
}
